import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'icc-condition-table-audit',
  templateUrl: './condition-table-audit.component.html',
  styleUrls: ['./condition-table-audit.component.less'],
})
export class ConditionTableAuditComponent implements OnInit {
  constructor() {}
  @Input() tableData: Array<any>;
  @Input() config;
  @Input() openEffect = true;
  // 数据操作状态
  operate = {
    normal: 0,
    add: 1,
    delete: 2,
    update: 3,
  };
  ngOnInit() {}
}
